import apiNtzTemplate from '@/api/ntz-template'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  deleteNtzTemplateStart: '[delete ntz template] Delete ntz template start',
  deleteNtzTemplateSuccess: '[delete ntz template] Delete ntz template success',
  deleteNtzTemplateFailure: '[delete ntz template] Delete ntz template failure',
}

export const actionTypes = {
  deleteNtzTemplate: '[delete ntz template] Delete ntz template',
}

const mutations = {
  [mutationTypes.deleteNtzTemplateStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.deleteNtzTemplateSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.deleteNtzTemplateFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.deleteNtzTemplate](context, {id}) {
    context.commit(mutationTypes.deleteNtzTemplateStart)
    return new Promise((resolve) => {
      apiNtzTemplate
        .deleteNtzTemplate(id)
        .then((response) => {
          context.commit(mutationTypes.deleteNtzTemplateSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.deleteNtzTemplateFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
